import { render, staticRenderFns } from "./preview-wrapper.vue?vue&type=template&id=b22cdcfe&scoped=true"
import script from "./preview-wrapper.vue?vue&type=script&lang=js"
export * from "./preview-wrapper.vue?vue&type=script&lang=js"
import style0 from "./preview-wrapper.vue?vue&type=style&index=0&id=b22cdcfe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b22cdcfe",
  null
  
)

export default component.exports